import { i18n } from '@fs/zion-locale'

export default {
  applyToAllVolumes: () => i18n.t('EditableCoverage.toggle.applyToAllVolumes', 'Apply to all volumes'),
  placeHelpText: () =>
    i18n.t('EditableCoverages.placeHelperText', 'This place applies to all the record types and dates below.'),
  recordType: () => i18n.t('EditableCoverage.recordType', 'Record Type'),
  learnMore: i18n.t('common-ui:learn-more.action'),
  recordNotStandardized: () =>
    i18n.t(
      'EditableCoverage.recordNotStandardized',
      'This place is not standardized. You can still save your changes.'
    ),
  placeAll: () => i18n.t('EditableCoverages.placeAll', 'Place'),
  selectPlace: () => i18n.t('EditableCoverage.selectPlace', 'Select Place'),
  selectRecordType: (name) => i18n.t('EditableCoverage.selectRecordType', 'Select Record Type {name}', { name }),
}
